module.exports = __webpack_public_path__ + "static/media/amarok-2.09c8deec.webp";